import { uploadPcTrack } from 'shihuo-lib';

const SsoUploadTrack = (id, biz = {}) => {
    // 生产环境上报
    if(/^(sso\.shizhi-inc\.com)$/.test(window.location.host)) {
        uploadPcTrack({
            pti: {
                id,
                biz: JSON.stringify(biz),
            },
            channel: '',
        });
    }
};

export default SsoUploadTrack;
